/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ZipNotifyCompleteResponse } from './ZipNotifyCompleteResponse';

export type ZipNotifyCompleteResponseApiRespoonse = {
    data?: ZipNotifyCompleteResponse;
    status?: ZipNotifyCompleteResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ZipNotifyCompleteResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

